module.exports = "<nav class=\"navbar\">\n    <a class=\"navbar-brand\" routerLink=\"\">\n        <img src=\"../assets/images/logo.png\" height=\"50\" width=\"200px\" alt=\"Material YouTube's logo\">\n    </a>\n    <a href=\"/search\">\n        <button type=\"button\" class=\"btn btn-primary raleway btn-small\">\n            <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n            <span class=\"btn-title\">Search</span>\n        </button>\n    </a>\n</nav>\n\n<div class=\"spacer\">\n    &nbsp;\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.html
// module id = ./src/app/navbar/navbar.component.html
// module chunks = main